import store from '@/store';

/**
 * 刷新令牌的工具函数
 *
 * @param {boolean} force 是否强制刷新，忽略时间间隔限制
 * @returns {Promise} 刷新令牌的Promise
 */
export function refreshToken() {
  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return store.dispatch('user/refresh_token', force);
}

/**
 * 设置令牌刷新定时器
 * 只会设置一次，不会重复设置
 */
export function setupRefreshTimer() {
  store.dispatch('user/setupRefreshTimer');
}

/**
 * 获取上次刷新令牌的时间
 *
 * @returns {number} 上次刷新令牌的时间戳
 */
export function getLastRefreshTime() {
  return store.state.user.lastRefreshTime;
}

/**
 * 检查是否需要刷新令牌
 *
 * @param {number} minInterval 最小刷新间隔（毫秒）
 * @returns {boolean} 是否需要刷新令牌
 */
export function shouldRefreshToken() {
  var minInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30 * 60 * 1000;
  var lastRefreshTime = getLastRefreshTime();
  return Date.now() - lastRefreshTime > minInterval;
}